import React from 'react';
import { Poppins, StyledLink } from 'src/common';
import styled from 'styled-components';
import { BaseCard, Row } from '../../styled';
import { numeralFormat } from 'src/utils/misc';
import { DashboardQuery } from 'src/graphql/_generated';
import { AssessmentState } from '../types';
import { DangerTooltip } from '../comps';

const Wrap = styled(BaseCard)`
  .links {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
`;

interface RiskyScenariosV2Props {
  value: DashboardQuery['dashboard']['riskyScenarios'];
  state: AssessmentState;
}

export const RiskyScenariosV2: React.FC<RiskyScenariosV2Props> = ({ value, state }) => {
  return (
    <Wrap>
      <span className="c-title">Risky Scenarios</span>
      <span className="description">These scenarios have the largest contribution to your overall risk posture.</span>

      <div style={{ flex: 1 }} />
      {state === 'NO_SCENARIOS' ? (
        <DangerTooltip state={state} />
      ) : (
        <div className="links">
          {value?.scenarios.map((s, idx) => (
            <Row key={s.id}>
              <Poppins px={14} weight={500} nowrap>
                {idx + 1}.{' '}
                <StyledLink to={`/risk-assessments/${s.assessment.id}/scenario/${s.id}`}>{s.name}</StyledLink>
              </Poppins>
              <div className="separator" />
              <Poppins weight={600} color="gp1" px={14}>
                {numeralFormat(s.liveRisk.expectedLoss)}
              </Poppins>
            </Row>
          ))}
        </div>
      )}
    </Wrap>
  );
};
